import { Component, OnDestroy, OnInit } from '@angular/core';
import { LoaderService } from '../../core/services/loader.service';
import { Observable, Subscription } from 'rxjs';

@Component({
  selector: 'app-spinner',
  standalone: false,
  templateUrl: './spinner.component.html',
  styleUrl: './spinner.component.scss'
})
export class SpinnerComponent implements OnInit, OnDestroy{
  loading = false;
  private subscription: Subscription = new Subscription();

  constructor(private loader: LoaderService) {}

  ngOnInit(): void {
    this.subscription = this.loader.getLoading().subscribe((loading: boolean) => {
      this.loading = loading;
    });
  }

  ngOnDestroy(): void {
    if (this.subscription) {
      this.subscription.unsubscribe();
    }
  }
}

